/* Rimtek — interactions des pages internes
   Galerie produit, sélecteur de variantes, quantité, accordéons, panier AJAX. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      try { return window.Shopify.formatMoney(cents); } catch (e) { /* ignore */ }
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MRU';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function toast(msg) {
    var old = document.querySelector('.rt-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'rt-toast';
    el.setAttribute('role', 'status');
    el.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"></path></svg>';
    el.appendChild(document.createTextNode(msg));
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2400);
  }

  function bumpCartCount() {
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-rt-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.add('rt-bump');
          setTimeout(function () { el.classList.remove('rt-bump'); }, 250);
        });
      });
  }

  /* ---------- Galerie produit ---------- */
  function initGallery(scope) {
    scope.querySelectorAll('[data-rt-gallery]').forEach(function (gal) {
      var main = gal.querySelector('[data-rt-gallery-main]');
      if (!main) return;
      gal.querySelectorAll('.rt-thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;
          main.innerHTML = '';
          var img = document.createElement('img');
          img.src = src;
          img.alt = alt;
          main.appendChild(img);
          gal.querySelectorAll('.rt-thumb').forEach(function (t) {
            t.classList.toggle('rt-active', t === thumb);
          });
        });
      });
    });
  }

  /* ---------- Quantité ---------- */
  function initQty(scope) {
    scope.querySelectorAll('[data-rt-qty]').forEach(function (box) {
      if (box.dataset.rtQtyBound) return;
      box.dataset.rtQtyBound = '1';
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'up' ? 1 : -1;
          var min = parseInt(input.min, 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          if (next < min) next = min;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Accordéons ---------- */
  function initAccordions(scope) {
    scope.querySelectorAll('.rt-acc__btn').forEach(function (btn) {
      if (btn.dataset.rtAccBound) return;
      btn.dataset.rtAccBound = '1';
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.classList.toggle('rt-open', !open);
      });
    });
  }

  /* ---------- Sélecteur de variantes ---------- */
  function initVariants(scope) {
    scope.querySelectorAll('[data-rt-product]').forEach(function (form) {
      var dataEl = form.querySelector('[data-rt-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[data-rt-variant-id]');
      var priceEl = form.querySelector('[data-rt-price]');
      var oldEl = form.querySelector('[data-rt-old-price]');
      var saveEl = form.querySelector('[data-rt-save]');
      var stockEl = form.querySelector('[data-rt-stock]');
      var submit = form.querySelector('[data-rt-submit]');
      var mainMedia = document.querySelector('[data-rt-gallery-main]');

      function selectedOptions() {
        var values = [];
        form.querySelectorAll('[data-rt-option]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          values[parseInt(group.dataset.rtOption, 10)] = checked ? checked.value : null;
        });
        return values;
      }

      function update() {
        var chosen = selectedOptions();
        var match = variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });

        if (!match) {
          if (submit) { submit.disabled = true; submit.textContent = 'Indisponible'; }
          if (stockEl) { stockEl.textContent = 'Combinaison indisponible'; stockEl.classList.add('rt-pdp__stock--out'); }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);

        if (oldEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            oldEl.textContent = money(match.compare_at_price);
            oldEl.hidden = false;
            if (saveEl) {
              saveEl.textContent = '-' + Math.round((1 - match.price / match.compare_at_price) * 100) + '%';
              saveEl.hidden = false;
            }
          } else {
            oldEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        }

        if (stockEl) {
          stockEl.textContent = match.available ? 'En stock — expédition sous 24h' : 'Épuisé';
          stockEl.classList.toggle('rt-pdp__stock--out', !match.available);
        }

        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? 'Ajouter au panier' : 'Épuisé';
        }

        if (match.featured_image && mainMedia) {
          mainMedia.innerHTML = '';
          var img = document.createElement('img');
          img.src = match.featured_image;
          img.alt = match.title;
          mainMedia.appendChild(img);
        }

        if (history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      form.querySelectorAll('[data-rt-option] input').forEach(function (input) {
        input.addEventListener('change', update);
      });

      /* Envoi AJAX */
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (!idInput || !idInput.value) return;
        var qtyInput = form.querySelector('[data-rt-qty] input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (submit) submit.disabled = true;
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(idInput.value), quantity: qty })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function (item) {
            bumpCartCount();
            toast((item.product_title || 'Article') + ' — ajouté au panier');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(function () { toast("Impossible d'ajouter cet article"); })
          .finally(function () { if (submit) submit.disabled = false; });
      });

      update();
    });
  }

  /* ---------- Page panier ---------- */
  function refreshCart(container) {
    var sectionId = container.dataset.rtCart;
    container.classList.add('rt-busy');
    fetch(root + 'cart?section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-rt-cart]');
        if (fresh) {
          container.innerHTML = fresh.innerHTML;
          initQty(container);
          bindCart(container);
        }
        bumpCartCount();
      })
      .catch(function () { window.location.reload(); })
      .finally(function () { container.classList.remove('rt-busy'); });
  }

  function changeLine(container, key, quantity) {
    container.classList.add('rt-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(container); })
      .catch(function () { window.location.reload(); });
  }

  function bindCart(container) {
    container.querySelectorAll('[data-rt-line-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(container, btn.dataset.rtLineRemove, 0);
      });
    });
    container.querySelectorAll('[data-rt-line-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 1;
        changeLine(container, input.dataset.rtLineQty, qty);
      });
    });
  }

  function initCart(scope) {
    scope.querySelectorAll('[data-rt-cart]').forEach(function (container) {
      initQty(container);
      bindCart(container);
    });
  }

  /* ---------- Sélecteur de langue ---------- */
  function initLocalization(scope) {
    scope.querySelectorAll('.rt-loc__select').forEach(function (select) {
      if (select.dataset.rtLocBound) return;
      select.dataset.rtLocBound = '1';
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ---------- Tri collection ---------- */
  function initSort(scope) {
    scope.querySelectorAll('[data-rt-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  function init(scope) {
    var s = scope || document;
    /* Signale la barre d'achat collante pour décaler le bouton WhatsApp flottant */
    if (document.querySelector('.rt-buy')) {
      document.body.setAttribute('data-rt-sticky-buy', '');
    }
    initGallery(s);
    initQty(s);
    initAccordions(s);
    initVariants(s);
    initCart(s);
    initSort(s);
    initLocalization(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
